import styled from 'styled-components';
import { StyleVars, typeScale } from 'core/utils';

const Section = styled.section`
	padding: ${typeScale(2)} 0;

	@media(max-width: ${StyleVars.screenSm}) {
		padding-top: ${typeScale(2)};
		padding-bottom: 0;
	}
`;

export default Section;
